// Fotos und Dateien zum Lead bzw. Termin: Einordnungen, Größenangabe, Vorschau (Dominik 14.10.2026).

export const maxAttachmentBytes = 25 * 1024 * 1024;

export const photoCategories: [string, string][] = [
  ['EXTERIOR', 'Außenansicht'],
  ['INTERIOR', 'Innenansicht'],
  ['VIEW', 'Ausblick/Balkon'],
  ['PHOTO', 'Foto'],
];

export const documentCategories: [string, string][] = [
  ['FLOOR_PLAN', 'Grundriss/Schnitt/Ansicht'],
  ['ENERGY', 'Energieausweis'],
  ['LAND_REGISTRY', 'Grundbuch'],
  ['CONTRACT', 'Vertrag'],
  ['RENT', 'Mietaufstellung'],
  ['OTHER', 'Sonstiges'],
];

export const attachmentAccept = 'image/*,.heic,.heif,.pdf,.doc,.docx,.xls,.xlsx,.pptx';

export function fmtBytes(n: number): string {
  if (n < 1024 * 1024) return `${Math.max(1, Math.round(n / 1024))} KB`;
  return `${(n / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

// previewable: Fotos, die jeder Browser zeigt (HEIC nur Safari – dort als Datei).
export function previewable(contentType: string): boolean {
  return ['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(contentType);
}
